import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../atoms/Icon';
import BundleIcon from '../../../assets/images/bundle-icon.png';


/**
 * A simple BundleDisplay.
 */

const bundleDescription = desc => {
	return {__html:desc.split("\r").join("<br>")}
}

class BundleDisplay extends React.Component {

    render () {
    	
        return (
          <div className="bundledisplay">
	          <div className="display">
	          	<div className="inner">
		            <Icon filename="selected" />
		            <h3>{this.props.bundle.deviceName}</h3>
		            <img src={BundleIcon} className="bundleicon" alt="bundleicon" />
	            </div>
	          </div>
	           <div className="specs">
	          	<div className="inner">
	                <h3>Paketinhalt:</h3>
	                <p dangerouslySetInnerHTML={bundleDescription(this.props.bundle.deviceDescription)}/>
              	</div>
              </div>
	        </div>
        );
    }

}

BundleDisplay.propTypes = {
	/** Button label */
	bundle: PropTypes.object.isRequired
}



export default BundleDisplay;





// WEBPACK FOOTER //
// ./src/components/molecules/BundleDisplay/BundleDisplay.js